const IssueIntensity = {
    Error: 'error',
    Info: 'info'
}

export default IssueIntensity